import { render, staticRenderFns } from "./dev-system-sidebar.vue?vue&type=template&id=758c519d&scoped=true"
import script from "./dev-system-sidebar.vue?vue&type=script&lang=js"
export * from "./dev-system-sidebar.vue?vue&type=script&lang=js"
import style0 from "./dev-system-sidebar.vue?vue&type=style&index=0&id=758c519d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c519d",
  null
  
)

export default component.exports